import { Globe } from "lucide-react";

export default function VisitorsMap({ visits }) {
  const pins = (visits || []).filter((v) => typeof v.lat === "number" && typeof v.lon === "number");
  const cities = new Set(pins.map((v) => `${v.city}|${v.country}`)).size;

  return (
    <div data-testid="visitors-map-card" className="mt-6 bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] rounded-2xl p-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="font-ui text-xs tracking-[0.2em] uppercase text-[#4A4A4A] flex items-center gap-2">
          <Globe size={14} className="text-[#C71E2E]" /> Visitor Map — Recent Sessions
        </p>
        <p data-testid="visitors-map-count" className="text-sm font-ui text-[#4A4A4A]">
          {pins.length} located visit{pins.length === 1 ? "" : "s"} · {cities} {cities === 1 ? "city" : "cities"}
        </p>
      </div>
      <div className="relative mt-4 rounded-xl overflow-hidden border border-[#E5DED5]">
        <img src="/assets/world-map.jpg" alt="World map of recent visitors" className="w-full block" loading="lazy" />
        {pins.map((v) => (
          <div
            key={v.id}
            data-testid={`visitor-pin-${v.id}`}
            className="absolute w-2.5 h-2.5 rounded-full bg-[#C71E2E] shadow-[0_0_10px_rgba(199,30,46,0.8)] hover:scale-150 transition-transform"
            style={{ left: `${((v.lon + 180) / 360) * 100}%`, top: `${((90 - v.lat) / 180) * 100}%`, transform: "translate(-50%, -50%)" }}
            title={`${[v.city, v.country].filter(Boolean).join(", ") || "Unknown"} · ${v.ip} · ${v.pageviews || 1} views`}
          />
        ))}
        {pins.length === 0 && (
          <p data-testid="visitors-map-empty" className="absolute inset-0 flex items-center justify-center text-sm font-ui text-[#4A4A4A] bg-white/60">
            Pins appear here as visitors browse the site with city-level geo.
          </p>
        )}
      </div>
    </div>
  );
}
